import React, { PropTypes } from 'react';
import { Link, hashHistory } from 'react-router';
import { Modal, message, Spin, Button, Input, Select } from 'antd';
import DataService from '../../lib/DataService';
import SharedTools from '../../lib/SharedTools';
import CurrentRoleStore from '../../stores/CurrentRoleStore';
import ChooseStudentsModule from './ChooseStudentsModule';
import PayModal from "../share/PayModal";

const Option = Select.Option;

export default class ArchiveRecordIndexPage extends React.Component {

  constructor(props) {
    super(props);
    // set state
    let role = CurrentRoleStore.getCurrentRole();
    let semester = SharedTools.getCurrentSemester();

    let year = Number(String(semester).substring(0, 4));
    let currentTime = (role.associatObj.pay_slice == 'semester' ? semester : role.associatObj.pay_slice == 'term'? year : null);

    let showCurrentAlbum = true;
    if (role.roleName == 'parent') {
      if(currentTime){
        let item = role.associatObj.paid_semesters.find(semester => {
          return String(currentTime).indexOf(String(semester)) >= 0 ? true : false
        })
        showCurrentAlbum = item ? true : false
      }
    }

    this.state = {
      currentRole: CurrentRoleStore.getCurrentRole(),
      archive: {},
      pageId: null,
      templateId: null,
      pageContent: [],
      backupPageContent: [],
      changePage: {},
      deletePage: {},
      showDetail:false,
      isShowChooseStudentsBox: false,
      choosedTemplate: {},
      dragPageIndex: 0,
      valid: true,
      loading: true,
      showCurrentAlbum,
      showPayModal: false,
      studentSelectType: 'normal',
      semesters: [],
      semester: props.location.query.semester ? props.location.query.semester : semester
    };
    // bind this
    this.onCurrentRoleChange = this.onCurrentRoleChange.bind(this);
    this.changeTheme = this.changeTheme.bind(this);
    this.deleteTheme = this.deleteTheme.bind(this);
    this.goChooseThemePage = this.goChooseThemePage.bind(this);
    this.goDeletePage = this.goDeletePage.bind(this);
    this.showChooseStudentsBox = this.showChooseStudentsBox.bind(this);
    this.handleShowChooseStudentsBox = this.handleShowChooseStudentsBox.bind(this);
    this.hideChooseStudentsBox = this.hideChooseStudentsBox.bind(this);
    this.hideTemplateModal = this.hideTemplateModal.bind(this);
    this.onPageDragStart = this.onPageDragStart.bind(this);
    this.onPageDragEnd = this.onPageDragEnd.bind(this);
    this.onPageDragEnter = this.onPageDragEnter.bind(this);
    this.onPageDragLeave = this.onPageDragLeave.bind(this);
    this.onPageDragOver = this.onPageDragOver.bind(this);
    this.onPageDrop = this.onPageDrop.bind(this);

    // 修改模版名称
    this.changeEditInput = this.changeEditInput.bind(this);
    this.editTheme = this.editTheme.bind(this);
    this.okEditTheme = this.okEditTheme.bind(this);

    // 添加页数
    this.addOnePage = this.addOnePage.bind(this)
    this.removeEmptyPage = this.removeEmptyPage.bind(this)
  }

  componentDidMount() {
    CurrentRoleStore.addChangeListener(this.onCurrentRoleChange);
    let currentSemester = SharedTools.getCurrentSemester(), semester = this.state.semester;
    if (this.state.currentRole.associatName != 'classRecord' && this.state.currentRole.associatName != 'student') {
      let classId = this.props.params.classId;
      let schoolId = this.props.params.schoolId;

      DataService.getClassById(classId).then(result => {
        if (result.archive_semester_count == 1) {
          semester = String(semester).substring(0, 4) + '1';
        } else {
          semester = semester;
        }
        this.toolSemesters(currentSemester, result.archive_semester_count)
        DataService.getArchives(classId, semester).then(res => {
          let archiveType = res.quality == 'hardback' ? 1 : 0;
          let pageContent = Array(res.page_count + 1).fill(false);
          if (res.pages) {
            res.pages.map(page => {
              if (page.page_type === 'front_cover') {
                pageContent[0] = page;
              } else if (page.page_type == 'inside') {
                pageContent[page.page_number] = page;
              }
            })
            res.state = true
          }
          if (archiveType == 0) {
            pageContent.splice(1, 0, false);
          }
          this.setState({
            pageContent: pageContent,
            archive: res,
            classId,
            schoolId,
            loading: false,
            className: result.name,
            semester
          })
        }).catch((error) => {
          message.error("获取成长记录失败")
          this.setState({ valid: false, loading: false })
          console.log(error);
        })
      }).catch((error) => {
        console.log(error);
      })
    } else if (this.state.currentRole.associatName == "classRecord") {
      DataService.getClassById(this.state.currentRole.associatObj.id).then(result => {
        if (result.archive_semester_count == 1) {
          semester = String(semester).substring(0, 4) + '1';
        } else {
          semester = semester;
        }
        this.toolSemesters(currentSemester, result.archive_semester_count)
        DataService.getArchives(this.state.currentRole.associatObj.id, semester).then(res => {
          let archiveType = res.quality == 'hardback' ? 1 : 0;
          let pageContent = Array(res.page_count + 1).fill(false);
          if (res.pages) {
            res.pages.map(page => {
              if (page.page_type === 'front_cover') {
                pageContent[0] = page;
              } else if (page.page_type == 'inside') {
                pageContent[page.page_number] = page;
              }
            })
            res.state = true
          }
          if (archiveType == 0) {
            pageContent.splice(1, 0, false);
          }
          this.setState({
            pageContent: pageContent,
            archive: res,
            classId: this.state.currentRole.associatObj.id,
            schoolId: this.state.currentRole.associatObj.schoolId,
            loading: false,
            className: result.name,
            semester
          })
        }).catch((error) => {
          message.error("获取成长记录失败")
          this.setState({valid: false, loading: false})
          console.log(error);
        })
      }).catch((error) => {
        console.log(error);
      })
    } else if (this.state.currentRole.associatName == "student"){
      DataService.getOneStudentInfo(this.state.currentRole.associatObj.id).then((result) => {
        if (result.archive_semester_count == 1) {
          semester = String(semester).substring(0, 4) + '1';
        } else {
          semester = semester;
        }
        this.toolSemesters(currentSemester, result.archive_semester_count)
        DataService.getStudentArchive(this.state.currentRole.associatObj.id, semester).then(res => {
          let pageContent = [];
          if (res.pages.length > 0) {
            res.pages.map(page => {
              pageContent.push(page);
            })
            res.state = true
          }

          this.setState({
            pageContent: pageContent,
            archive: res,
            studentId: this.state.currentRole.associatObj.id,
            classId: this.state.currentRole.associatObj.classId,
            schoolId: this.state.currentRole.associatObj.schoolId,
            loading: false,
            semester
          })
        }).catch((error) => {
          message.error("获取成长记录失败")
          this.setState({valid: false, loading: false})
          console.log(error);
        })
      }).catch((error) => {
        console.log(error)
      })
    }
  }

  getArchives() {
    DataService.getArchives(this.state.classId, this.state.semester).then(res => {
      let archiveType = res.quality == 'hardback' ? 1 : 0;
      let pageContent = Array(res.page_count + 1).fill(false);
      if (res.pages) {
        res.pages.map(page => {
          if (page.page_type === 'front_cover') {
            pageContent[0] = page;
          } else if (page.page_type == 'inside') {
            pageContent[page.page_number] = page;
          }
        })
        res.state = true
      }
      if (archiveType == 0) {
        pageContent.splice(1, 0, false);
      }
      this.setState({
        pageContent: pageContent,
        archive: res,
        loading: false,
        valid: true,
      })
    }).catch((error) => {
      message.error("获取成长记录失败")
      this.setState({ valid: false, loading: false })
      console.log(error);
    })
  }

  getStudentArchive() {
    DataService.getStudentArchive(this.state.currentRole.associatObj.id, this.state.semester).then(res => {
      let pageContent = [];
      if (res.pages.length > 0) {
        res.pages.map(page => {
          pageContent.push(page);
        })
        res.state = true
      }

      this.setState({
        pageContent: pageContent,
        archive: res,
        loading: false,
        valid: true
      })
    }).catch((error) => {
      message.error("获取成长记录失败")
      this.setState({ valid: false, loading: false })
      console.log(error);
    })
  }

  toolSemesters(currentSemester, archive_semester_count) {
    let semesters = SharedTools.getAllSemesters(currentSemester, 20171, archive_semester_count)
    this.setState({
      semesters
    })
  }

  // componentDidMount(){
  // }

  componentWillUnmount(){
    CurrentRoleStore.removeChangeListener(this.onCurrentRoleChange);
  }

  onCurrentRoleChange() {
    this.setState({
      currentRole: CurrentRoleStore.getCurrentRole()
    });
  }

  changeTheme(e) {
    e.stopPropagation();
    let pageContent = this.state.pageContent;
    let {position, index, number} = e.currentTarget.dataset;

    let showModal = false;
    let changePage = {
      position: position,
      index: index,
      number: number
    };

    let page = pageContent.find(p => p.page_type == "inside" && p.page_number == number);
    if (page && page.complete_count !== 0) {
      showModal = true;
      changePage.complete_count = page.complete_count;

      this.setState({
        changePage: changePage,
        showModal: showModal
      })
    } else {
      hashHistory.push(`archive/content-setting/schools/${this.state.schoolId}/classes/${this.state.classId}/choose-template?pageNumber=${changePage.number}&archiveId=${this.state.archive.id}`);
    }
  }

  deleteTheme(e) {
    e.stopPropagation();
    let {pid} = e.currentTarget.dataset;
    let page = this.state.pageContent.find(p => p.page_type == "inside" && p.id == pid);
    if (page && page.complete_count >= 0) {
      this.setState({
        deletePage: {
          id: page.id,
          complete_count: page.complete_count
        },
        showModal: true
      })
    }
  }

  editTheme(e) {
    e.stopPropagation();
    let { pid } = e.currentTarget.dataset;
    let page = this.state.pageContent.find(p => p.id == pid);

    if (page.template.t_type == "album" && !page.album_id) {
      message.info("请先进入页面指定相册后再更改名称", 3)
      return
    }
    if (page && page.complete_count >= 0) {
      this.setState({
        editPage: {
          id: page.id,
          comment: ''
        },
        showEditModal: true
      })
    }
  }


  changeEditInput(e) {
    let editPage = this.state.editPage;
    editPage.comment = e.target.value;
    this.setState({
      editPage
    })
  }

  okEditTheme() {
    let { id, comment } = this.state.editPage;
    let page = this.state.pageContent.find(p => p.page_type == "inside" && p.id == id);
    if (comment) {
      if (page.template.t_type == 'album') {
        DataService.batchChangeClassPageContentAlbumTitle(this.state.classId, id, comment).then((res) => {
          this.getArchives()
          this.setState({
            editPage: {},
            showEditModal: false,
            // pageContent: this.state.pageContent
          })
        }).catch((error) => {
          message.error('修改相册名称失败，请稍后重试');
        })
      } else {
        DataService.createComment(id, comment).then(() => {
          let page = this.state.pageContent.find(p => p.id == id);
          page.comment = comment;
          this.setState({
            editPage: {},
            showEditModal: false,
            pageContent: this.state.pageContent
          })
        }).catch((error) => {
          if (error && error.errorMessage && error.errorMessage.errors[0].code == 11) {
            message.error('模版名称不能为空!');
          } else {
            message.error('模版名称修改失败，请重试!');
          }
        })
      }

    } else {
      message.error('模版名称不能为空!');
    }
  }

  goChooseThemePage() {
    this.setState({
      showModal: false,
      changePage: {}
    })
    hashHistory.push(`archive/content-setting/schools/${this.state.schoolId}/classes/${this.state.classId}/choose-template?pageNumber=${this.state.changePage.number}&archiveId=${this.state.archive.id}`);
  }

  goDeletePage() {
    let pageId = this.state.deletePage.id;
    DataService.removeTheme(pageId).then(() => {
      let index = this.state.pageContent.findIndex(p => p.id == pageId);
      this.state.pageContent.splice(index, 1, false);
      this.setState({
        pageContent: this.state.pageContent,
        showModal: false,
        deletePage: {}
      })
    })
  }

  showChooseStudentsBox(pageId, templateId) {
    let page = this.state.pageContent.find(item => item && item.template.id == templateId);
    let studentSelectType = (page.template && page.template.student_select_type) ? page.template.student_select_type : 'normal';
    let templateType = (page.template && page.template.t_type) ? page.template.t_type : 'normal';

    this.setState({
      isShowChooseStudentsBox: true,
      templateId: parseInt(templateId),
      pageId: parseInt(pageId),
      studentSelectType,
      templateType
    })
  }

  handleShowChooseStudentsBox(e){
    let {pageid, templateid}= e.currentTarget.dataset;

    this.showChooseStudentsBox(pageid, templateid);
  }

  hideChooseStudentsBox() {
    this.setState({
      isShowChooseStudentsBox: false,
    })
  }

  hideTemplateModal() {
    this.setState({
      showTemplateModal: false,
      choosedTemplate: {},
      choosedTemplateAuthor: '',
    })
  }

  onPageDragStart(e) {
    let {pindex} = e.currentTarget.dataset;
    this.setState({
      dragPageIndex: pindex,
      backupPageContent: SharedTools.cloneObject(this.state.pageContent)
    })
  }

  onPageDragEnd(e) {
    let {pindex} = e.currentTarget.dataset;

    this.setState({
      dragPageIndex: null,
    })
  }

  onPageDragEnter(e) {
    let {pindex} = e.currentTarget.dataset;

    if (!this.state.dragPageIndex || !pindex) {
      return
    }

    let dragPageIndex = this.state.dragPageIndex
    let overPageIndex = pindex

    this.state.pageContent = SharedTools.cloneObject(this.state.backupPageContent)
    let dragPage = this.state.pageContent[dragPageIndex]
    let overPage = this.state.pageContent[overPageIndex]

    // Deprecated: insert source element to target position
    // if (Number(dragPageIndex) > Number(overPageIndex)) {
    //   this.state.pageContent.splice(dragPageIndex, 1)
    //   this.state.pageContent.splice(overPageIndex, 0, dragPage)
    // } else if (Number(dragPageIndex) < Number(overPageIndex)) {
    //   this.state.pageContent.splice(Number(overPageIndex) + 1, 0, dragPage)
    //   this.state.pageContent.splice(dragPageIndex, 1)
    // }

    // swap source element and the element at target position
    let archiveType = this.state.archive.quality == 'hardback' ? 1 : 0;
    if (overPage) {
      overPage.page_number = Number(dragPageIndex) - 1 + archiveType;
    }
    if (dragPage) {
      dragPage.page_number = Number(overPageIndex) - 1 + archiveType;
    }

    this.state.pageContent[dragPageIndex] = overPage
    this.state.pageContent[overPageIndex] = dragPage



    this.setState({
      pageContent: this.state.pageContent,
    })
  }

  onPageDragLeave(e) {
    let {pindex} = e.currentTarget.dataset;
    this.state.pageContent = SharedTools.cloneObject(this.state.backupPageContent)
    this.setState({
      pageContent: this.state.pageContent,
    })
  }

  onPageDragOver(e) {
    e.preventDefault();
  }

  callbackPayModal() {
    this.setState({
      showPayModal: false
    })
  }

  onPageDrop(e) {
    let {pindex} = e.currentTarget.dataset;

    let pagesOrder = {}
    let somePageChanged = this.state.pageContent.map((p, index) => {
      if (p && p.page_type == "inside") {
        // 构造数据时除去封面，page 在 pageContent 的 index 和 page.page_number 一致（硬壳有偏移）
        // 拖拽调整顺序后新的顺序信息保存在 page index，没有改动 page.page_number
        pagesOrder[p.id] = index - 1 + (this.state.archive.quality == 'hardback' ? 1 : 0);
        return p.id == (this.state.backupPageContent[index] || {}).id
      }
      return true
    })
    if (!somePageChanged.reduce((r, c) => r && c)) {
      DataService.reorderPages(this.state.archive.id, JSON.stringify(pagesOrder))
    }
  }

  // 添加页数
  addOnePage() {
    let archiveId = this.state.archive.id;
    let data = {
      archive_id: archiveId,
      count: 1
    }
    DataService.addPageCount(data).then((res) => {
      this.getArchives()
      message.success('添加成功');
    }).catch((error) => {
      if (error.errorMessage && error.errorMessage.errors[0].code == 54) {
        message.error('当前学校页数固定，无法添加页数');
        return
      }
      message.error('添加页数失败');
    })
  }

  // 删除空白页
  removeEmptyPage() {
    let archiveId = this.state.archive.id;
    DataService.removeEmptyPage(archiveId).then((res) => {
      this.getArchives()
      message.success('删除成功');
    }).catch((error) => {
      if (error.errorMessage && error.errorMessage.errors[0].code == 51) {
        message.error('该页已配置模板，无法删除');
        return
      }
      message.error('删除空白页失败');
    })
  }

  _insidePages() {
    let archiveType = this.state.archive.quality == 'hardback' ? 1 : 0;
    let pages = [];
    if (this.state.pageContent.length <= 0) {
      return;
    }
    if(this.state.currentRole.roleName == "teacher"){
      pages.push(
        <div className="page-detail-box front-cover-box" key='page-0'>
          <div className="page-right front-cover" data-templateId={this.state.pageContent[0].template.id} data-pageId={this.state.pageContent[0].id} onClick={this.handleShowChooseStudentsBox}>
            <div className="page-number">封面</div>
            <div className="review">{this.state.pageContent[0].author_type=='teacher'?"":"家长"}已做{this.state.pageContent[0].complete_count}/{this.state.pageContent[0].student_count}</div>
            <div className="img-cover" style={{"background": `url(${this.state.pageContent[0].template.icon_url})`, backgroundSize: '4.5rem 4.5rem'}}></div>
            <div className="title">{this.state.pageContent[0].comment || this.state.pageContent[0].template.title}</div>
            {(this.state.pageContent[0] && this.state.pageContent[0].template && !this.state.pageContent[0].show_answer) ? <div className="edit-btn" onClick={this.editTheme} data-pid={this.state.pageContent[0].id}>修改模版名称</div> : ''}
          </div>
        </div>
      )
      for (let i = 1; i < this.state.pageContent.length; i += 2) {
        let index = (i + 1) / 2;
        let leftPage  = this.state.pageContent[i];
        let rightPage = this.state.pageContent[i + 1];
        pages.push(
          <TeacherPageDetailBox showChooseStudentsBox={this.showChooseStudentsBox} key={`page-${index}-${leftPage && leftPage.id}-${rightPage && rightPage.id}`}
                         archiveId={this.state.archive.id}
                         currentRole={this.state.currentRole}
                         classId={this.state.classId}
                         index={index} left={leftPage} right={rightPage}
                         leftNumber={i - 1 + archiveType}
                         archiveType={archiveType}
                         pageCount={this.state.archive.page_count} changeTheme={this.changeTheme} deleteTheme={this.deleteTheme} editTheme={this.editTheme}
                         onPageDragStart={this.onPageDragStart} onPageDragEnd={this.onPageDragEnd}
                         onPageDragEnter={this.onPageDragEnter} onPageDragLeave={this.onPageDragLeave}
                         onPageDrop={this.onPageDrop} onPageDragOver={this.onPageDragOver}
                        addOnePage={this.addOnePage}
                        removeEmptyPage={this.removeEmptyPage}
        />)
      }
    }else if(this.state.currentRole.roleName == "parent"){
      for (let i = 0; i < this.state.pageContent.length; i += 1) {
        pages.push(
          <ParentPageDetailBox showChooseStudentsBox={this.showChooseStudentsBox} key={`page-${i}`} pageContent={this.state.pageContent[i]} classId={this.state.classId} studentId={this.state.studentId} archiveId={this.state.archive.id} />)
      }
    }
    return (<div>
              {pages}
              {/* {this.state.currentRole.associatName == 'system' ? this._addPageView() : ''} */}
              {this.state.currentRole.roleName != "parent" ? this._addPageView() : ''}
            </div>)
  }

  // 添加页面
  _addPageView() {
    let index = this.state.pageContent.length % 2;
    switch(index) {
      case 1:
        return <div className="page-detail-box front-cover-box">
                <div className="page-left first-page" onClick={this.addOnePage}>
                  <div className="add-label">添加</div>
                  <div className="add-label">页数</div>
                </div>
              </div>
        break;
      default:
        return ''
    }
  }

  _changeThemeModal() {
    let modalData = {};
    if (this.state.changePage.number) {
      modalData.title = "更换模版";
      modalData.text = `已有${this.state.changePage.complete_count}位宝贝完成了此模版，更换后已填写的内容将清除，确认更换模版吗？`;
      modalData.onBtnClick = this.goChooseThemePage;
      modalData.btnText = "去更换";
    } else if (this.state.deletePage.id) {
      modalData.title = "删除模版";
      modalData.onBtnClick = this.goDeletePage;
      modalData.btnText = "确认删除"
      if (this.state.deletePage.complete_count > 0) {
        modalData.text = `已有${this.state.deletePage.complete_count}位宝贝完成了此模版，删除后已填写的内容将清除，确认删除模版吗？`;
      } else {
        modalData.text = "确认删除模版吗？";
      }
    }

    return (
      <Modal
        className="archive-content-setting-class-page-change-theme-modal"
        title={null}
        visible={this.state.showModal}
        footer={null}
        onCancel={() => {this.setState({showModal: false, changePage: {}, deletePage: {}})}}
      >
        <div className="title">{modalData.title}</div>
        <div className="text">{modalData.text}</div>
        <div className="btn" onClick={modalData.onBtnClick}>{modalData.btnText}</div>
      </Modal>
    )
  }

  _editThemeModal() {
    return (
      <Modal
        className="archive-content-setting-class-page-change-theme-modal"
        title="更换模版名称"
        visible={this.state.showEditModal}
        footer={null}
        onCancel={() => { this.setState({ showEditModal: false, editPage: {} }) }}
      >
        <label>模版名称更换为: </label>
        <Input placeholder="请输入模版名称" style={{ marginLeft: 20, width: '50%' }} onChange={this.changeEditInput} value={this.state.editPage ? this.state.editPage.comment : ''}></Input>
        <div className="btn" onClick={this.okEditTheme}>确认</div>
      </Modal>
    )
  }

  // 选择学期

  selectSemester(value) {
    if (value != this.state.semester) {
      this.setState({
        semester: value,
      }, () => {
        if (this.state.currentRole.roleName == 'parent') {
          this.getStudentArchive()
        } else {
          this.getArchives()
        }
        this.props.location.query.semester = value;
        hashHistory.replace(this.props.location);
      })
    }
  }

  _selectSemesterBox() {
    return (
      <div className="select-semester-box">
        <Select value={String(this.state.semester)} style={{ width: 145 }} onChange={this.selectSemester.bind(this)}>
          {this.state.semesters.map((semester, index) => <Option value={String(semester.semester)} key={index}>{semester.semesterToString}</Option>)}
        </Select>
      </div>
    )
  }

  render() {
    let { className } = this.state;
    return (
     <Spin spinning={this.state.loading} size="large">
        {!this.state.loading ? <div className="archive-record-index-page archive-content-setting-class-page">
          {this._selectSemesterBox()}
          {(!this.state.showCurrentAlbum) ? <div className="no-paid-semester">
            <div>学期未解锁</div>
            <div style={{fontSize: '14px'}}>嘟嘟养成记小程序解锁该学期后可查看内容</div>
            <div><Button type="primary" onClick={() => this.setState({showPayModal: true})}>去解锁</Button></div>
          </div> : <div>
              {!this.state.valid &&
                <div className="error-no-archive">获取成长记录失败，请刷新重试...</div>
              }
              {this.state.valid && !this.state.archive.state && (this.state.currentRole.roleName == "parent") &&
                <div className="error-no-pages">老师还没发布任务哦～过段时间再来看看呗～</div>
              }
              <div className="tips-reorder" style={{fontSize: '18px'}}>
                {this.state.currentRole.roleName == "teacher" ? className : ''}
              </div>
              <div className="tips-reorder">按住档案内页拖动可调整顺序</div>
              {this.state.valid && this.state.archive.state && this._insidePages()}
              {this._changeThemeModal()}
              {this._editThemeModal()}
              <ChooseStudentsModule visible={this.state.isShowChooseStudentsBox} onCancel={this.hideChooseStudentsBox} author="teacher" pageId={this.state.pageId} templateId={this.state.templateId} classId={this.state.classId} archiveId={this.state.archive.id} studentSelectType={this.state.studentSelectType} templateType={this.state.templateType}/>
            </div>
          }
          <PayModal visible={this.state.showPayModal} studentId={this.state.currentRole.associatObj.id} callbackPayModal={this.callbackPayModal.bind(this)}/>
        </div> : ''}
      </Spin>
    )
  }
}

class ParentPageDetailBox extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pageContent: props.pageContent,
      classId: props.classId,
      studentId: props.studentId,
      archiveId: props.archiveId,
    }

    this.toEditTemplate = this.toEditTemplate.bind(this);
    this.toViewTemplate = this.toViewTemplate.bind(this);
  }

  toEditTemplate(page) {
    let {studentId, classId}= this.state;
    if (page.template.t_type == 'album') {
      message.info('请等待老师选择相册')
      return
    } else if (page.template.t_type == 'story') {
      message.info('请在小程序端查看故事')
      return
    }
    hashHistory.push(`archive/record/edit/?studentIds=[${studentId}]&pageId=${page.id}&templateId=${page.template.id}&classRecordId=${classId}&archiveId=${this.state.archiveId}`)
  }

  toViewTemplate(page) {
    let {studentId, classId}= this.state;
    if (page.template.t_type == 'album') {
      message.info('请在小程序端选择宝贝照片')
      return
    } else if (page.template.t_type == 'story') {
      message.info('请在小程序端查看故事')
      return
    }
    hashHistory.push(`archive/record/edit/?studentIds=[${studentId}]&pageId=${page.id}&templateId=${page.template.id}&classRecordId=${classId}&archiveId=${this.state.archiveId}&status=changeable`)
  }


  render() {
    let page = this.state.pageContent;
    return (
      <div className="page-detail-box" style={{width: '10%', minWidth: "0", margin:"10px 30px"}}>
        {page && (
          <div className="page-left" style={{ width: '160px' }} data-page={page} onClick={page.is_finished ? this.toViewTemplate.bind(this, page) : this.toEditTemplate.bind(this, page)}>
            <div className="img-cover" style={{marginTop: '20px', marginBottom: '20px', "background": `url(${page.template.icon_url}) no-repeat`, backgroundSize: '4.5rem 4.5rem'}}></div>
            <div className="title">{page.template.title}</div>
            <div className="title">{page.comment}</div>
            {(page && page.template && page.template.show_answer) ? <div className="title">{page.template.t_type == 'album' ? (page.album_title ? page.album_title : '') : page.theme_title}</div> : ''}
            <div className={"review" + (page.is_finished ? "" : " unfinished")}>{page.is_finished ? "已完成" : "未完成"}</div>
          </div>
        )}
      </div>
    )
  }
}

class TeacherPageDetailBox extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      left: props.left,
      right: props.right,
      leftNumber: props.leftNumber,
      rightNumber: Number(props.leftNumber) + 1,
      pindex: props.leftNumber + 1 - props.archiveType,
      pageCount: props.pageCount,
      archiveId: props.archiveId,
      classId: props.classId,
    }

    this.showChooseStudentsBox = this.showChooseStudentsBox.bind(this);
    this.onPageDragStart = this.props.onPageDragStart;
    this.onPageDragEnd = this.props.onPageDragEnd;
    this.onPageDragEnter = this.props.onPageDragEnter;
    this.onPageDragLeave = this.props.onPageDragLeave;
    this.onPageDragOver = this.props.onPageDragOver;
    this.onPageDrop = this.props.onPageDrop;
    this.addOnePage = this.props.addOnePage;
    this.removeEmptyPage = this.props.removeEmptyPage;
  }

  componentWillReceiveProps(newProps) {
    this.setState({
      left: newProps.left,
      right: newProps.right,
      pageCount: newProps.pageCount
    })
  }

  showChooseStudentsBox(e) {
    let { pageid, templateid, type }= e.currentTarget.dataset;

    if (type == 'true') {
      DataService.getAllStudents(this.state.classId).then((students) => {
        var student_ids = students.map((item) => item.id)
        hashHistory.push(`archive/record/edit/?studentIds=[${student_ids}]&pageId=${pageid}&templateId=${templateid}&archiveId=${this.state.archiveId}`);
      }).catch((error) => {
      })
    } else {
      this.props.showChooseStudentsBox(pageid, templateid);
    }
  }


  render() {
    let {left, right, leftNumber, rightNumber, pageCount} = this.state;
    let {currentRole} = this.props;
    return (
      <div className="page-detail-box">
        {left && (
          <div className="page-left" data-position="left" data-templateId={left.template.id} data-pageId={left.id} data-type={left.template.show_answer} onClick={this.showChooseStudentsBox} draggable="true" data-pindex={this.state.pindex} onDragStart={this.onPageDragStart} onDragEnd={this.onPageDragEnd} onDragEnter={this.onPageDragEnter} onDragLeave={this.onPageDragLeave} onDragOver={this.onPageDragOver} onDrop={this.onPageDrop}>
            <div className="page-number">
              <span className="number">{leftNumber}</span>页
            </div>
            <div className="img-cover" style={{"background": `url(${left.template.icon_url}) no-repeat`, backgroundSize: '4.5rem 4.5rem'}}></div>
            <div className="title">{left.template.title}</div>
            <div className="title">{left.comment}</div>
            {(left && left.template && left.template.show_answer) ? <div className="title">{left.template.t_type == 'album' ? (left.album_title ? left.album_title : '') : left.theme_title}</div> : ''}
            <div className="review">{left.author_type=='teacher'?"":"家长"}已做{left.complete_count}/{left.student_count}</div>
            {(left && left.template && !(left.template.t_type == "no_render" && left.template.show_answer)) ? <div className="edit-btn" onClick={this.props.editTheme} data-pid={left.id}>修改模版名称</div> : ''}
            <div className="change-btn" onClick={this.props.changeTheme} data-number={leftNumber} data-position="left" data-index={this.props.index}>更换</div>
            <div className="delete-btn" onClick={this.props.deleteTheme} data-pid={left.id}>删除</div>
          </div>
        )}
        {!left && (leftNumber !== 0) && (
          <div className="page-left empty" draggable="true" data-pindex={this.state.pindex} onDragStart={this.onPageDragStart} onDragEnd={this.onPageDragEnd} onDragEnter={this.onPageDragEnter} onDragLeave={this.onPageDragLeave} onDragOver={this.onPageDragOver} onDrop={this.onPageDrop}>
            {/* {(leftNumber == pageCount && currentRole.associatName == 'system') ? <div className="remove-page" onClick={this.removeEmptyPage}> */}
            {(leftNumber == pageCount ) ? <div className="remove-page" onClick={this.removeEmptyPage}>
                                          删除空白页
                                        </div> : ''}
            <div className="add-page" onClick={this.props.changeTheme} data-number={leftNumber} data-position="left" data-index={this.props.index}>+</div>
            <div className="page-number empty">第{leftNumber}页</div>
          </div>
        )}
        {!left && (leftNumber === 0) && (
          <div className="page-left first-page" onClick={this.addOnePage}>
            <div>首页</div>
            <div>空白</div>
          </div>
        )}

        {((right && left) || (!right && (rightNumber === pageCount + 1)) || (!left && (leftNumber === 0))) && <div className="divide-line"></div>}

        {right && (
          <div className="page-right" data-position="right" data-templateId={right.template.id} data-pageId={right.id} data-type={right.template.show_answer} onClick={this.showChooseStudentsBox} draggable="true" data-pindex={this.state.pindex + 1} onDragStart={this.onPageDragStart} onDragEnd={this.onPageDragEnd} onDragEnter={this.onPageDragEnter} onDragLeave={this.onPageDragLeave} onDragOver={this.onPageDragOver} onDrop={this.onPageDrop}>
            <div className="page-number">
              <span className="number">{rightNumber}</span>页
            </div>
            <div className="img-cover" style={{"background": `url(${right.template.icon_url})`, backgroundSize: '4.5rem 4.5rem'}}></div>
            <div className="title">{right.template.title}</div>
            <div className="title">{right.comment}</div>
            {(right && right.template && right.template.show_answer) ? <div className="title">{right.template.t_type == 'album' ? (right.album_title ? right.album_title : '') : right.theme_title}</div> : ''}
            <div className="review">{right.author_type=='teacher'?"":"家长"}已做{right.complete_count}/{right.student_count}</div>
            {(right && right.template && !(right.template.t_type == "no_render" && right.template.show_answer)) ? <div className="edit-btn" onClick={this.props.editTheme} data-pid={right.id}>修改模版名称</div> : ''}
            <div className="change-btn" onClick={this.props.changeTheme} data-number={rightNumber} data-position="right" data-index={this.props.index}>更换</div>
            <div className="delete-btn" onClick={this.props.deleteTheme} data-pid={right.id}>删除</div>
          </div>
        )}
        {!right && (rightNumber !== pageCount + 1) && (
          <div className="page-right empty" draggable="true" data-pindex={this.state.pindex + 1} onDragStart={this.onPageDragStart} onDragEnd={this.onPageDragEnd} onDragEnter={this.onPageDragEnter} onDragLeave={this.onPageDragLeave} onDragOver={this.onPageDragOver} onDrop={this.onPageDrop}>
            {/* {(rightNumber == pageCount && currentRole.associatName == 'system') ? <div className="remove-page" onClick={this.removeEmptyPage}> */}
            {(rightNumber == pageCount && currentRole.roleName != "parent") ? <div className="remove-page" onClick={this.removeEmptyPage}>
                                          删除空白页
                                        </div> : ''}
            <div className="add-page" onClick={this.props.changeTheme} data-number={rightNumber} data-position="right" data-index={this.props.index}>+</div>
            <div className="page-number empty">第{rightNumber}页</div>
          </div>
        )}
        {/* {!right && (rightNumber === pageCount + 1) && currentRole.associatName == 'system' && ( */}
        {!right && (rightNumber === pageCount + 1) && currentRole.roleName != "parent" && (
            <div className="page-right last-page" onClick={this.addOnePage}>
            <div className="add-label">添加</div>
            <div className="add-label">页数</div>
          </div>
        )}
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./app/javascript/bundles/WebPcApp/components/archive/ArchiveRecordIndexPage.jsx